import Frames from "@frog/source/engine/animating/Frames.js"

export default {
    "frames": Frames.run({
        "tweentime": 80,
        "images": [
            require("./spawneranim-multi3-0000.png"),
            require("./spawneranim-multi3-0001.png"),
            require("./spawneranim-multi3-0002.png"),
            require("./spawneranim-multi3-0003.png"),
            require("./spawneranim-multi3-0004.png"),
            require("./spawneranim-multi3-0005.png"),
            require("./spawneranim-multi3-0006.png"),
            require("./spawneranim-multi3-0007.png"),
            require("./spawneranim-multi3-0008.png"),
            require("./spawneranim-multi3-0009.png"),
            require("./spawneranim-multi3-0010.png"),
            require("./spawneranim-multi3-0011.png"),
            require("./spawneranim-multi3-0012.png"),
            require("./spawneranim-multi3-0013.png"),
            require("./spawneranim-multi3-0014.png"),
            require("./spawneranim-multi3-0015.png"),
        ]
    })
}
